import { MemberSearchResultItem } from 'store/modules/search/searchService/types';

export const memberActionURL = (member: Partial<MemberSearchResultItem>) =>
  `/members/${member.uuid ?? ''}`;
